import { render, staticRenderFns } from "./ReportLegend.vue?vue&type=template&id=e4831388&scoped=true&"
import script from "./ReportLegend.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ReportLegend.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ReportLegend.vue?vue&type=style&index=0&id=e4831388&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4831388",
  null
  
)

export default component.exports